/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {useMemo} from 'react';

// private function to calculate the page constraint by using page, pageSize and limit
export const hasConstraintExceeded = (page: number, pageSize: number, limit: number) => page * pageSize > limit;

/**
 * The `usePageConstraints` hook determines if the given page constraint has
 * been exceeded based on the provided page, pageSize and limit.
 *
 * ```typescript
 *
 *  import {usePageConstraints} from '@ion/dls/src/grid/';
 *
 *  const isConstraintExceeded = usePageConstraints({pageConstraint, page, pageSize});
 *
 * ```
 */
export const usePageConstraints = ({
  pageConstraint,
  page,
  pageSize
}): boolean => {
  return useMemo(() => {
    return hasConstraintExceeded(page, pageSize, pageConstraint);
  }, [page, pageSize, pageConstraint]);
};

export default usePageConstraints;
